import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

import { Col, Input, Row } from 'reactstrap';

import { connect } from 'react-redux';
import { compose } from 'redux';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import { createStructuredSelector } from 'reselect';
import reducer from 'containers/Offer/reducer';
import saga from 'containers/Offer/saga';

import { printOffer } from './actions';
import {
  makeSelectOfferSelector,
  makeSelectServicesSelector,
  makeSelectAccessoriesCodesSelector,
  makeSelectColorCodesSelector,
  makeSelectMonthlyRateSelector,
} from '../CustomizeOffer/selectors';

import { CONTRACTUAL_CATEGORIES } from '../CarQuote/constants';
import './styles.scss';

class PrintForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      employee_category: '',
    };
  }

  /**
   *
   * @param e
   */
  onNameChange = e => {
    const name = e.target.value;
    this.setState(() => ({ name }));
  };

  /**
   *
   * @param e
   */
  onEmployeeCategoryChange = e => {
    const employee_category = e.target.value;
    this.setState(() => ({
      employee_category,
    }));
  };

  handelOnPrint = e => {
    const { offer, services, accessories, colors, newMonthlyRate } = this.props;
    const { name, employee_category } = this.state;
    e.preventDefault();
    this.props.print(
      offer.ref,
      newMonthlyRate,
      name,
      employee_category,
      accessories,
      colors,
    );
  };

  render() {
    const categories = [
      {
        description: 'Seleziona...',
        value: '',
        type: 'PRIVATE',
        secondaryType: 'PRIVATE',
      },
      ...CONTRACTUAL_CATEGORIES,
    ];

    return (
      <div className="print">
        <div className="content">
          <Row>
            <Col md={6} sm={6}>
              <label htmlFor="name" ref={this.firstNameRef}>
                Nome
              </label>
              <Input
                name="name"
                id="name"
                placeholder="Nome cliente"
                value={this.state.name}
                onChange={this.onNameChange}
                autoComplete="given-name"
              />
            </Col>
            <Col md={6} sm={6}>
              <div className="FormField">
                <label htmlFor="employee_category" ref={this.categoryRef}>
                  Occupazione&nbsp;
                </label>
                <Input
                  type="select"
                  name="employee_category"
                  value={this.state.employee_category}
                  onChange={this.onEmployeeCategoryChange}
                >
                  {categories.map(item => (
                    <option key={item.value} value={item.value}>
                      {item.description}
                    </option>
                  ))}
                </Input>
              </div>
            </Col>
          </Row>
          <div className="text-center">
            <button
              className="btn-action"
              type="button"
              onClick={this.handelOnPrint}
            >
              {' '}
              Stampa Offerta{' '}
            </button>
          </div>
          <FormattedMessage {...messages.terms} tagName="p" />
        </div>
      </div>
    );
  }
}

PrintForm.propTypes = {
  offer: PropTypes.any.isRequired,
};

export function mapDispatchToProps(dispatch) {
  return {
    print: (
      offer,
      price,
      name,
      category,
      accessories,
      colors,
    ) =>
      dispatch(
        printOffer(
          offer,
          price,
          name,
          category,
          accessories,
          colors,
        ),
      ),
  };
}

const mapStateToProps = createStructuredSelector({
  offer: makeSelectOfferSelector(),
  newMonthlyRate: makeSelectMonthlyRateSelector(),
  services: makeSelectServicesSelector(),
  accessories: makeSelectAccessoriesCodesSelector(),
  colors: makeSelectColorCodesSelector(),
});

const withReducer = injectReducer({ key: 'offer', reducer });
const withSaga = injectSaga({ key: 'offer', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(PrintForm);
